// Teacher Timetable - re-uses student Timetable with context
import Timetable from '../student/Timetable';
export default Timetable;
